import axiosClient from './axiosClient';

const SurveyReportApi = {
  getSurveyReportList: (data = {}) =>
    axiosClient.post('/api/survey/adminPannelBySurvey', data),

  getSurveyUsers: (data = {}) =>
    axiosClient.post('/api/survey/surveyBasedUsers', data),

  getUserbasedAnswer: (data = {}) =>
    axiosClient.post('/api/survey/userBasedAnswer', data),

  getUserSurveyAnswers: (data = {}) =>
    axiosClient.post('/api/survey/userBasedAnswer', data),
  
  getSurveyBasedAnalytics: (data = {}) =>
    axiosClient.post('/api/survey/getSurveyBasedAnalytics', data),
};

export default SurveyReportApi;
